import { ListView } from "@repo/skapa";
import { type PropsWithChildren } from "react";

type FilterListContainerProps = PropsWithChildren & {
  id: string;
};

export const FilterListContainer = ({
  children,
  id,
}: FilterListContainerProps) => {
  return (
    <ListView id={`${id}-list`} size="small">
      {children}
    </ListView>
  );
};
